import React from "react";
import PropTypes from "prop-types";
import { Button, CardSection } from "cxa-components";
import messages from "components/messagesDescription";

const AccountsExhaustedInfo = ({ intl }) => {
  return (
    <CardSection>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px 0",
        }}
      >
        <p>
          <b>{intl.formatMessage(messages.accountExhaustedDescription)}</b>
        </p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button type="button" secondary to="/claims/submit">
          {intl.formatMessage(messages.backButtonDescription)}
        </Button>
      </div>
    </CardSection>
  );
};

AccountsExhaustedInfo.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default AccountsExhaustedInfo;



// WEBPACK FOOTER //
// ./components/claim/widgets/AccountsExhaustedInfo.jsx